import Record from './record-class/record.js'
import voicePlay from './play/index.js'


import voiceRecord from './record/record.js'


let voice = {
    Record,
    ...voicePlay,
}

Vue.use(voiceRecord, {
    // router: VueRouter.router,
    root: voice
});


export default voice;